import { render, staticRenderFns } from "./RejectRemarkDialog.vue?vue&type=template&id=ae6c8030"
import script from "./RejectRemarkDialog.vue?vue&type=script&lang=js"
export * from "./RejectRemarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports